import { DeleteOutlined } from '@ant-design/icons'
import type { MouseEvent } from 'react'

import AtomButton from '@/components/Atoms/AtomButton/AtomButton'
import AtomSelect from '@/components/Atoms/AtomSelect/AtomSelect'
import HoverElement from '@/components/Atoms/HoverElement/HoverElement'
import { useUserInfoStore } from '@/stores/user/userInfoStore'

import cn from './ExcelSheetControls.module.scss'

type ExcelSheetControlsProps = {
  sheetNames: string[]
  activeSheetName: string
  selectedSheetNames: string[]
  onActiveSheetChange: (sheetName: string) => void
  onSelectedSheetsChange: (sheetNames: string[]) => void
  onReset: () => void
}

const preventDropdownClose = (event: MouseEvent) => event.preventDefault()

function ExcelSheetControls({
  sheetNames,
  activeSheetName,
  selectedSheetNames,
  onActiveSheetChange,
  onSelectedSheetsChange,
  onReset,
}: ExcelSheetControlsProps) {
  const isOrganisationSelected = useUserInfoStore(
    (state) => Object.keys(state.selectedOrganisation).length > 0
  )
  const options = sheetNames.map((name) => ({ value: name, label: name }))

  return (
    <div className={cn.controls}>
      {sheetNames.length > 1 ? (
        <HoverElement>
          <AtomSelect
            outlined
            size="large"
            openByHover={false}
            isOrganisationSelected={isOrganisationSelected}
            options={options}
            value={activeSheetName}
            handleChange={(value) => {
              if (typeof value === 'string') onActiveSheetChange(value)
            }}
          />
        </HoverElement>
      ) : (
        <div className={cn.activeSheet} title={activeSheetName}>
          {activeSheetName}
        </div>
      )}
      <HoverElement>
        <AtomSelect
          outlined
          size="large"
          mode="multiple"
          openByHover={false}
          isOrganisationSelected={isOrganisationSelected}
          options={options}
          value={selectedSheetNames}
          maxTagCount="responsive"
          placeholder="Какие листы читать"
          onValuesChange={onSelectedSheetsChange}
          popupRender={(menu) => (
            <>
              <div
                className={cn.dropdownActions}
                onMouseDown={preventDropdownClose}
              >
                <AtomButton
                  variant="secondary"
                  onClick={() => onSelectedSheetsChange(sheetNames)}
                >
                  Выбрать все
                </AtomButton>
                <AtomButton
                  variant="secondary"
                  onClick={() => onSelectedSheetsChange([])}
                >
                  Снять все
                </AtomButton>
              </div>
              {menu}
            </>
          )}
        />
      </HoverElement>
      <AtomButton
        variant="secondary"
        icon={<DeleteOutlined />}
        onClick={onReset}
      >
        Сбросить файл
      </AtomButton>
    </div>
  )
}

export default ExcelSheetControls
